<template>
  <div>
    <hm-content title="批量设置商品价格">
      <div class="button-panel flex flex-end item-center">
        <el-button type="primary" size="small" @click="outputExcel"
        >导出模板</el-button
        >
        <el-button type="primary" size="small" @click="operateDialogVisible = true"
        >导入</el-button
        >
      </div>
      <div class="inputDeep">
        <el-table :data="tableData" stripe border style="width: 100%">
          <div slot="empty" style="margin-top: 118px">
            <div class="hmicon icon-a-zanwushuju2x"></div>
            <div>暂无数据</div>
          </div>
          <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="tag"
              label="标签"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="updateType"
              label="修改价格类型"
          >
          <template slot-scope="scope">
              <span v-if="scope.row.updateType==='wxshop_price'">售价</span>
              <span v-if="scope.row.updateType==='member_price'">会员价</span>
          </template> 
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="commitTime"
              label="提交时间"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="auditState"
              label="审核状态"
          >
          <template slot-scope="scope">
              <span class="blue" v-if="scope.row.auditState==='wait'">待审核</span>
              <span class="success" v-if="scope.row.auditState==='agree'">已通过</span>
              <span class="danger" v-if="scope.row.auditState==='refuse'">已驳回</span>
          </template>             
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="auditTime"
              label="审核时间"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="auditUsername"
              label="审核人"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="goodsSn"
              label="操作"
          >
            <template slot-scope="scope">
              <el-button
                  @click="edit(scope.row)"
                  size="small"
                  class="blue"
                  type="text"
              >查看</el-button
              >
              <el-button
                  @click="audit(scope.row.id)"
                  size="small"
                  class="danger"
                  type="text"
                  v-if="scope.row.auditState==='wait'"
              >审核</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
        ></el-pagination>
      </div>
    </hm-content>
    <!-- 商品操作弹窗 -->
    <el-dialog
        width="800px"
        title="导入"
        :visible="operateDialogVisible"
        @close="operateDialogVisible = false"
    >      
      <div>
        <el-form
        :model="ruleForm"        
        ref="ruleForm"
        label-width="200px"
        >
          <el-form-item label="标签" prop="tag">
            <el-input
              clearable
              maxlength="50"
              @mousewheel.prevent.native
              v-model.trim="ruleForm.tag"
              placeholder="请输入标签"
              size="small"
              class="ipt mr10"
            ></el-input>
          </el-form-item>
          <el-form-item label="修改价格类型" prop="updateType">
            <el-radio-group
            v-model="ruleForm.updateType"
            @change="updateType"
          >
            <el-radio label="wxshop_price">售价</el-radio>
            <el-radio label="member_price">会员价</el-radio>
          </el-radio-group>
          <el-select
            clearable
            filterable
            size="small"
            class="ml20"
            v-model="ruleForm.groupId"
            placeholder="请选择会员群组"
            v-show="isShowMemberGroupList"
            @change="MemberGroupListChange"
          >
            <el-option
              :label="v.groupAppellation"
              :value="v.groupId"
              v-for="(v, i) in memberGroupList"
              :key="i"
            ></el-option>
          </el-select>
          </el-form-item>
          <div class="flex" ref="select_frame">
          <div class="import-btn open-file">
              <div class="add-wrapper">
                <span class="hmicon icon-hao pointer"></span>
              </div>
              <span>点击导入</span>
              <input
                type="file"
                @change="importf"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </div>
            <div class="flex flex-column flex-end">
              <!-- <div class="tips">点击或将文件拖拽到这里导入</div> -->
              <div v-if="fileName" class="danger">已上传{{ fileName }}</div>
              <div>文件后缀名必须为xls,xlsx,及csv，文件大小不得大于3M</div>
            </div>
          </div>
        </el-form>
      </div>
      <div class="btn-wrapper flex flex-center mt20">
        <el-button
            size="small"
            type="primary"
            @click="addRuleForm"
        >确定</el-button
        >
        <el-button
            size="small"
            type="info"
            @click="operateDialogVisible = false"
        >取消</el-button
        >
      </div>
    </el-dialog>
    <!-- 添加商品弹窗 -->
    <el-dialog
        width="1200px"
        title="查看"
        :visible="editDialogVisible"
        @close="editDialogVisible = false"
    >
      <div class="mt20">
        <el-table
            stripe
            border
            :data="goodsList"
            style="width: 100%"
            ref="goodsTable"
        >
          <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="(index) => index + (currentPage2 - 1) * pageSize + 1"
          ></el-table-column>     
          <el-table-column
              header-align="center"
              align="center"
              prop="groupName"
              label="会员群组"
              v-if="isShowgroupName"
          >
          </el-table-column>     
          <el-table-column
              header-align="center"
              align="center"
              prop="goodsSn"
              label="商品货号"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="barcode"
              label="商品条码"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="targetValue"
              label="修改后价格"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
            background
            :total="goodsListTotal2"
            @current-change="paging2"
            @size-change="handleSizeChange2"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage2"
        ></el-pagination>
      </div>
      <div class="btn-wrapper flex flex-center mt20">         
        <el-button
            size="small"
            type="info"
            @click="editDialogVisible = false"
        >关闭</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
        width="800px"
        title="审核"
        :visible="auditDialogVisible"
        @close="auditDialogVisible = false"
    >
      <div class="mt20">
        <el-form
        :model="ruleForm2"
        ref="ruleForm2"
        label-width="200px"
        >
        <el-form-item label="审核">
          <el-radio-group
          v-model="auditState"   
          @change="auditStateList"       
        >
          <el-radio label="agree">通过</el-radio>
          <el-radio label="refuse">驳回</el-radio>
        </el-radio-group>
        </el-form-item>
        </el-form>
      </div>
      <div class="btn-wrapper flex flex-center mt20">      
        <el-button
            size="small"
            type="primary"
            @click="auditSubmit"
        >确定</el-button
        >  
        <el-button
            size="small"
            type="info"
            @click="auditDialogVisible = false"
        >取消</el-button
        >
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
import { arrayUnique2 } from "@/utils/utils";
// import XLSX from "xlsx";
import * as XLSX from 'xlsx/xlsx'
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  name: "storeFinanceDayStatInfo",
  data() {
    return {
      currentAudit:"",
      auditState:"agree",
      auditStateText:"通过",
      ruleForm2:{},
      tBody:["goodsSn","barcode","targetValue"],
      fileName: "",
      isShowMemberGroupList:false,
      memberGroupList: [],
      ruleForm:{
        tag:"",
        updateType:"wxshop_price",
        groupId:"",
        groupName: "",
        batchUpdateDetailModelList:[],
      },
      operateDialogVisible:false,
      editDialogVisible: false,
      auditDialogVisible: false,
      isOutputing: false,
      isShowgroupName:false,
      // 导入失败弹窗
      errValidGoods: false,
      total: 0,
      tableData: [],
      // 关联码列表分页
      pageSize: 10,
      currentPage: 1,
      // 添加商品分页
      pageSize2: 10,
      currentPage2: 1,
      goodsList: [],
      goodsListTotal2: 0,
      rules: {
        tag:{
          required: true,
          trigger: "blur"
        },        
      },
    };
  },
  created() {
    this.queryMemberGroupList();
    this.queryList();
  },
  methods: {
    //导入确定按钮提交
    async addRuleForm(){
      if(!this.ruleForm.tag){
        this.$message({
          message: "请输入标签",
          type: "warning",
        });
        return false;
      }
      if(this.ruleForm.updateType==='member_price' && !this.ruleForm.groupId){
        this.$message({
          message: "请选择会员群组",
          type: "warning",
        });
        return false;
      }
      console.log("this.ruleForm:",this.ruleForm);
      let params = this.ruleForm;
      const { code, result } = await this.$store.dispatch(
          "addBatchUpdateRecord",
          params
      );
      console.log("result:",result);
      if (code == "0") {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.operateDialogVisible = false;
        this.queryList();
      } else {
        this.$message({
          message: result,
          type: "warning",
        });
      }
    },
    //会员群组切换
    MemberGroupListChange(e){
      console.log(e);
      this.memberGroupList.forEach(v=>{
        if(v.groupId===e){
          this.ruleForm.groupId = v.groupId;
          this.ruleForm.groupName = v.groupAppellation;
        }
      })
    },
    //修改价格类型
    updateType(e){
      console.log(e);
      if(e==='wxshop_price'){
        this.isShowMemberGroupList = false;
        this.ruleForm.groupId = "";
        this.ruleForm.groupName = "";
      }else{
        this.isShowMemberGroupList = true;
      }
    },
    auditStateList(e){
      if(e==='agree'){
        this.auditStateText="通过";
      }else if(e==='refuse'){
        this.auditStateText="驳回";
      }
    },
    //查询会员群组
    async queryMemberGroupList() {
      const { result } = await this.$store.dispatch("queryMemberGroupList", {
        pageNo: 1,
        pageSize: 9999
      });

      const { records } = result;
      this.memberGroupList = records;
    },
    //查询列表
    async queryList() {
      const { storeCode } = getLoginUser();
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        storeCode: storeCode,
      };
      const { result } = await this.$store.dispatch(
          "queryBatchUpdateRecordList",
          params
      );
      const { records, total } = result;
      this.tableData = records;
      this.total = total;
    },
    //查看详情
    async edit(row) {
      let params = {
        recordId : row.id,
      };
      const { code, result } = await this.$store.dispatch(
          "queryBatchUpdateRecordById",
          params
      );
      console.log("result",result);  
      const { records, total } = result;
      if (code == "0") {
        this.editDialogVisible = true;
        this.goodsList = records;
        if(row.groupName){
          this.goodsList.map(v=>{
            v.groupName = row.groupName;
          })
          this.isShowgroupName = true;
        }else{
          this.isShowgroupName = false;
        }
        this.goodsListTotal2 = total;
      } else {
        this.$message({
          message: result,
          type: "warning",
        });
      }    
    },
    audit(id){
      this.currentAudit = id;
      this.auditDialogVisible = true;
    },
    //审核
    auditSubmit(){
      console.log("this.currentAudit:",this.currentAudit);
      console.log("this.auditState",this.auditState);
      this.$confirm(" 是否确定审核"+this.auditStateText+"?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          id : this.currentAudit,
          auditState: this.auditState,
        };
        this.$store.dispatch("auditBatchUpdateRecord",params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
            this.auditDialogVisible = false;
          }
        });
      })
    },
    //列表翻页
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    // 查看详情表格翻页
    paging2(page) {
      this.currentPage2 = page;
      this.queryList2();
    },
    handleSizeChange2(size) {
      this.currentPage2 = 1;
      this.pageSize = size;
      this.queryList2();
    },
    search2() {
      this.currentPage2 = 1;
      this.queryList2();
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商品货号", "商品条码", "修改后价格"];
        const data = [];
        exportJsonToExcel(tHeader, data, "商品价格批量修改模板");
      });
    },
    // 导入数据
    importf(e) {
      const obj = e.target;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      this.fileName = f.name;
      console.log("this.fileName:",this.fileName);
      let reader = new FileReader();
      reader.onload = e => {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        console.log("result:",result);
        let formatResult = [];
        result.map((v, i) => {
          formatResult.push({});
          this.tBody.map((o, index) => {
            formatResult[i][this.tBody[index]] = v[index];
          });
        });
        console.log("formatResult:",formatResult);
        this.ruleForm.batchUpdateDetailModelList = formatResult;
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    // 导入失败确定刷新
    importErr(){
      this.errValidGoods = false
      this.queryList()
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    
  },
};
</script>

<style scoped lang="scss">
// .inputDeep >>> .el-input__inner {
//   border: 0;
//   background: none;
// }
.table-panel,
.button-panel {
  margin-bottom: 20px;
}
.add-btn,
.add-goods-btn {
  margin-right: auto;
}
.inputDeep {
  min-height: 550px;
}
.el-table th.el-table__cell.is-leaf {
  color: #222222;
}
.el-table tr {
  background: #f7f7f7;
}
.el-table::before {
  height: 0;
}
.icon-a-zanwushuju2x {
  font-size: 32px;
  margin-bottom: -30px;
}
// 批量删除
.icon-shanchu1 {
  font-size: 24px;
}
.mul-delete {
  cursor: pointer;
}
.err-valid-goods-tips {
  font-weight: bold;
}
.import-btn {
  border: 1px solid #ddd;
  text-align: center;
  padding: 28px;
  margin-right: 10px;
  cursor: pointer;
  margin-left:200px;
}
.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
</style>
